import { ShowDataFor } from 'utils/components/ShowDataFor/ShowDataFor';
import {
    FillsGraphStreamedDataConfiguration,
    initialFillsGraphStreamedDataConfiguration,
} from 'widgets/fillsGraph/store/streamedData/FillsGraphStreamedDataHelpers';

export type PerfVsIndexCapsuleView = 'chart' | 'values';

export interface PerfVsIndexCapsuleConfigState
    extends FillsGraphStreamedDataConfiguration {
    symbol?: string;
    showDataFor?: ShowDataFor;
    view: PerfVsIndexCapsuleView;
    symbolInTitle?: boolean;
    showIndexPerf?: boolean;
}

export const initialPerfVsIndexCapsuleConfigState: PerfVsIndexCapsuleConfigState =
    {
        ...initialFillsGraphStreamedDataConfiguration,
        showDataFor: ShowDataFor.AllDay,
        indexFallback: 'DEFAULT',
        view: 'chart',
    };
